// Bump when the shape of any key persisted to localStorage/sessionStorage changes
// (e.g. fallback_org, fallback_location). Users whose stored schema_version is
// lower will be force-logged-out on next app boot so their state is rebuilt cleanly.
export const APP_SCHEMA_VERSION = 1;
export const SCHEMA_VERSION_KEY = "schema_version";
